const loanRoutes = [

    {

        name: 'loanHome',
        path: '',
        component: () =>
            import('./ListLoans.vue'),
        meta: {
            auth: true,
            title: 'Finance Listing',
            breadcrumb: 'Finance Listing',
            permission: ['view loan']
        }

    },

    {
        path: 'customer-loans/:customerId',
        name: 'customerLoans',
        component: () =>
            import('./ListCustomerLoans.vue'),
        meta: {
            auth: true,
            title: 'Customer Loans',
            breadcrumb: 'Customer Loans',
            permission: ['view loan']
        },
        children: [

            {

                name: 'showCustomerLoan',
                path: ':loanId',
                component: () =>
                    import('./ListCustomerLoans.vue'),
                meta: {
                    auth: true,
                    title: 'Showing Customer Loan',
                    breadcrumb: 'Showing Customer Loan',
                    permission: ['view loan']
                }


            },

        ]
    },





    {
        path: 'show/:id',
        name: 'showLoan',
        component: () =>
            import('./ShowLoan.vue'),
        meta: {
            auth: true,
            title: 'Showing Loan Application',
            breadcrumb: 'Showing Loan Application',
            permission: ['view loan'],
        }

    },


    {
        path: 'viewaccount/:id',
        name: 'viewCustomerAccount',
        component: () =>
            import('./ViewAccount.vue'),
        meta: {
            auth: true,
            title: 'View Account',
            breadcrumb: 'View Account',
            permission: ['view loan']
        }

    },


    {
        path: 'installments-due',
        name: 'installmentsduereport',
        component: () =>
            import('./report/InstallmentsDueReport.vue'),
        meta: {
            auth: true,
            title: 'Installments Due Report',
            breadcrumb: 'Installments Due Report',
            permission: ['view-loan-reports']
        }

    },

    {
        path: 'defaulters',
        name: 'defaultersreport',
        component: () =>
            import('./report/LoanDefaultersReport.vue'),
        meta: {
            auth: true,
            title: 'Defaulters Report',
            breadcrumb: 'Defaulters Report',
            permission: ['view-loan-reports']
        }

    },

    {
        path: 'disbursementreport',
        name: 'facilitydisbursementreport',
        component: () =>
            import('./report/LoanPaymentReport.vue'),
        meta: {
            auth: true,
            title: 'Facility Disbursement Report',
            breadcrumb: 'Facility Disbursement Report',
            permission: ['view-loan-reports']
        }

    },

       {
        path: 'outstanding-portfolio',
        name: 'outstandingportfolio',
        component: () =>
            import('./report/BalanceAsAtReport.vue'),
        meta: {
            auth: true,
            title: 'Outstanding Portfolio',
            breadcrumb: 'Outstanding Portfolio',
            permission: ['view-loan-reports']
        }

    },



    {
        path: 'dormant-borrowers',
        name: 'dormantborrowers',
        component: () =>
            import('./report/DormantBorrowersReport.vue'),
        meta: {
            auth: true,
            title: 'Dormant Borrowers',
            breadcrumb: 'Dormant Borrowers',
            permission:['view-loan-reports']
        }

    },

        {
        path: 'branchdisbursement',
        name: 'branchdisbursementreport',
        component: () =>
            import('./report/BranchDisbursementReport.vue'),
        meta: {
            auth: true,
            title: 'Branch Disbursement Report',
            breadcrumb: 'Branch Disbursement Report',
            permission: ['view-loan-reports']
        }

    },

    {
        path: 'dailydisbursement',
        name: 'dailydisbursementreport',
        component: () =>
            import('./report/DailyDisbursementReport.vue'),
        meta: {
            auth: true,
            title: 'Daily Disbursement Report',
            breadcrumb: 'Daily Disbursement Report',
            permission: ['view-loan-reports']
        }

    },

    {
        path: 'monthlydisbursement',
        name: 'monthlydisbursementreport',
        component: () =>
            import('./report/MonthlyDisbursementReport.vue'),
        meta: {
            auth: true,
            title: 'Monthly Disbursement Report',
            breadcrumb: 'Monthly Disbursement Report',
            permission: ['view-loan-reports']
        }

    },

    {
        path: 'teamdisbursement',
        name: 'teamdisbursementreport',
        component: () =>
            import('./report/TeamDisbursementReport.vue'),
        meta: {
            auth: true,
            title: 'Team Disbursement Report',
            breadcrumb: 'Team Disbursement Report',
            permission: ['view-loan-reports']
        }

    },

    {
        path: 'productdisbursement',
        name: 'productdisbursementreport',
        component: () =>
            import('./report/ProductDisbursementReport.vue'),
        meta: {
            auth: true,
            title: 'Product Disbursement Report',
            breadcrumb: 'Product Disbursement Report',
            permission: ['view-loan-reports']
        }

    },

    {
        path: 'disbursementsummary',
        name: 'disbursementsummaryreport',
        component: () =>
            import('./report/DisbursementSummaryReport.vue'),
        meta: {
            auth: true,
            title: 'Disbursement Report',
            breadcrumb: 'Disbursement Report',
            permission: ['view-loan-reports']
        }

    },

    {
        path: 'disbursementdrivers',
        name: 'disbursementdriversreport',
        component: () =>
            import('./report/DisbursementDriversReport.vue'),
        meta: {
            auth: true,
            title: 'Disbursement Drivers',
            breadcrumb: 'Disbursement Drivers',
            permission: ['view-loan-reports']
        }

    },

    {
        path: 'categorydisbursement',
        name: 'categorydisbursementreport',
        component: () =>
            import('./report/CategoryDisbursementReport.vue'),
        meta: {
            auth: true,
            title: 'Product Category Performance Report',
            breadcrumb: 'Product Category Performance Report',
            permission: ['view-loan-reports']
        }

    },

    {
        path: 'installment-in-arrears',
        name: 'installmentinarrearsreport',
        component: () =>
            import('./report/InstallmentInArrearsReport.vue'),
        meta: {
            auth: true,
            title: 'Installment In Arrears Report',
            breadcrumb: 'Installment In Arrears Report',
            permission: ['view-loan-reports']
        }

    },

];

export default loanRoutes;
